import React from 'react';
import { useStudentProfile } from '../../hooks/useStudentProfile';
import { LearnerAvatar } from '../profile/LearnerAvatar';
import { BhriguReplyContent } from './BhriguReplyContent';
import { getAskGuideForSchool } from 'features/ai/lib/askGuideIdentity';

/**
 * @param {{
 *   role: 'user' | 'assistant';
 *   content?: string;
 *   isDark: boolean;
 *   showEnglish?: boolean;
 *   crisis?: boolean;
 *   loading?: boolean;
 *   cacheHit?: boolean;
 *   animate?: boolean;
 *   school?: string | null;
 *   faceUrl?: string;
 *   thinkingText?: string;
 * }} props
 */
export function BhriguChatMessage({
  role,
  content,
  isDark,
  showEnglish = true,
  crisis = false,
  loading = false,
  cacheHit = false,
  animate = false,
  school = null,
  faceUrl,
  thinkingText: thinkingTextProp,
}) {
  const { profile } = useStudentProfile();
  const isUser = role === 'user';
  const guide = getAskGuideForSchool(school);
  const face = faceUrl || guide.faceUrl;
  const objectPosition = guide.faceObjectPosition === 'top' ? 'object-top' : 'object-center';

  if (crisis) {
    return null;
  }

  const thinkingText =
    thinkingTextProp ||
    (showEnglish ? guide.thinkingEn : guide.thinkingHi);
  const cacheNote = showEnglish ? 'Matched existing answer' : 'मिलता-जुलता उत्तर';

  return (
    <div className={`mb-1 flex gap-2 ${animate ? 'bhrigu-message-in' : ''} ${isUser ? 'justify-end' : 'justify-start'}`}>
      {!isUser ? (
        <img
          src={face}
          alt=""
          className={`mt-auto h-10 w-10 shrink-0 rounded-full bg-transparent object-cover ${objectPosition} ${
            loading ? 'animate-pulse' : ''
          }`}
          aria-hidden
        />
      ) : null}
      <div
        className={`max-w-[min(75%,28rem)] px-3 py-2 text-sm leading-relaxed shadow-sm ${
          isUser
            ? `rounded-2xl rounded-br-sm ${
                isDark ? 'bg-emerald-600/90 text-white' : 'bg-emerald-500 text-white'
              }`
            : `rounded-2xl rounded-bl-sm ${
                isDark ? 'border border-white/10 bg-[#1f1f28] text-gray-100' : 'border border-gray-200 bg-white text-gray-900'
              } ${loading ? 'italic opacity-80' : ''}`
        } ${showEnglish ? '' : 'font-devanagari'}`}
        lang={showEnglish ? 'en' : 'hi'}
      >
        {loading ? (
          thinkingText
        ) : isUser ? (
          content
        ) : (
          <BhriguReplyContent content={content || ''} isDark={isDark} />
        )}
        {!loading && cacheHit ? (
          <p className={`mt-1 text-[10px] ${isUser ? 'text-white/70' : isDark ? 'text-gray-500' : 'text-gray-400'}`}>
            {cacheNote}
          </p>
        ) : null}
      </div>
      {isUser ? (
        <LearnerAvatar profile={profile} size="sm" isDark={isDark} showEnglish={showEnglish} fallback="user" className="mt-auto" />
      ) : null}
    </div>
  );
}
